import { RequestService } from '../../services/RequestService';
import { GET_DOCUMENTS_STATUSES } from '../constants';

export const getDocumentsStatuses = () => {
  return RequestService.get(GET_DOCUMENTS_STATUSES);
};
